import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { fmtNum } from "@/lib/studio";
import { RangeControls, WordsChart, bucketize, useStatsRange } from "@/components/studio/WordsChart";

const Panel = ({ title, total, unit, children, testid }) => (
  <section className="rounded-md border border-[#2D3442] bg-[#0F131A] p-5" data-testid={testid}>
    <div className="lf-label">{title}</div>
    <div className="mb-4 mt-1 font-display text-3xl text-[#F3EBDD]" data-testid={`${testid}-total`}>{fmtNum(total)} <span className="text-sm text-[#A8A090]">{unit}</span></div>
    {children}
  </section>
);

export const ActivityCharts = () => {
  const r = useStatsRange();
  const { data } = useQuery({ queryKey: ["me-stats-activity", r.params], queryFn: () => api.get("/me/stats/activity", { params: r.params }).then((x) => x.data) });
  const words = bucketize(data?.words || [], r.start, r.end, r.gran);
  const lore = bucketize(data?.lore || [], r.start, r.end, r.gran);
  const total = (list) => (list || []).reduce((a, h) => a + h.words, 0);
  return (
    <div className="space-y-4">
      <div className="flex justify-end"><RangeControls r={r} effective={words.gran} /></div>
      <div className="grid gap-4 lg:grid-cols-2">
        <Panel title={`Words written · per ${words.gran}`} total={total(data?.words)} unit="net words this period" testid="stats-words">
          <WordsChart rows={words.rows} testid="stats-words-chart" />
        </Panel>
        <Panel title={`Lore growth · per ${lore.gran}`} total={total(data?.lore)} unit="entries added this period" testid="stats-lore">
          <WordsChart rows={lore.rows} unit="entries" name="Added" color="#10B981" testid="stats-lore-chart" />
        </Panel>
      </div>
    </div>
  );
};
